"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.find");
var _paymentSettings = require("@/api/appBasicSetup/paymentSettings");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TransferAccount',
  data: function data() {
    return {
      showDialog: true,
      loading: false,
      // 支付宝转账账号列表数据
      alipayTableData: [],
      alipayTotal: 0,
      // 快安支付记账本列表数据
      kapayerTableData: [],
      kapayerTotal: 0,
      // 快安支付-基础配置
      kapayerBaseConfig: {
        appKey: '',
        appSecret: '',
        jobId: ''
      },
      page: 1,
      size: 20,
      total: 0,
      title: '',
      OperationType: '',
      dialogVisible: false,
      // 支付渠道列表
      channelList: [{
        label: '支付宝',
        value: 'alipay'
      }, {
        label: '快安支付',
        value: 'kapayer'
      }],
      // 顶部 tab 选中值（仅控制 tab 高亮 + 下方列表筛选）
      tabChannel: 'alipay',
      // 后端配置的真实"当前渠道"（控制右侧"当前渠道：xxx"显示）
      activeChannel: 'alipay',
      // 更换渠道弹窗
      changeChannelDialogVisible: false,
      // 弹窗内单选值
      changeChannelValue: 'alipay',
      // 快安支付-添加/编辑账本弹窗（共用）
      kapayerAddDialogVisible: false,
      // 'add' 新增 / 'edit' 编辑
      kapayerAddDialogType: 'add',
      // 编辑时的记账本主键 id
      kapayerAddEditingId: null,
      kapayerAddForm: {
        bookName: '',
        accountBookId: ''
      },
      kapayerAddRules: {
        bookName: [{
          required: true,
          message: '请输入账本名称',
          trigger: 'blur'
        }],
        accountBookId: [{
          required: true,
          message: '请输入账本ID',
          trigger: 'blur'
        }]
      },
      // 快安支付-编辑基础配置弹窗
      kapayerBaseEditDialogVisible: false,
      kapayerBaseEditForm: {
        appKey: '',
        appSecret: '',
        jobId: ''
      },
      kapayerBaseEditRules: {
        appKey: [{
          required: true,
          message: '请输入快安App Key',
          trigger: 'blur'
        }],
        appSecret: [{
          required: true,
          message: '请输入快安App Secret',
          trigger: 'blur'
        }],
        jobId: [{
          required: true,
          message: '请输入快安岗位 ID',
          trigger: 'blur'
        }]
      },
      ruFrom: {
        remark: '',
        alipayAppId: '',
        rootCertContent: '',
        publicKey: '',
        privateKey: '',
        alipayPublicCertContent: '',
        certContent: ''
      },
      rules: {
        // remark: [
        //   { required: true, message: '请输入备注名称', trigger: 'blur' }
        // ],
        // alipayAppId: [
        //   { required: true, message: '请输入支付宝APPID', trigger: 'blur' }
        // ]
        // rootCertContent: [
        //   { required: true, message: '请输入支付宝根证书', trigger: 'blur' }
        // ],
        // publicKey: [
        //   { required: true, message: '请输入支付宝公钥', trigger: 'blur' }
        // ],
        // privateKey: [
        //   { required: true, message: '请输入支付宝私钥', trigger: 'blur' }
        // ],
        // alipayPublicCertContent: [
        //   { required: true, message: '请输入支付宝公钥证书', trigger: 'blur' }
        // ],
        // certContent: [
        //   { required: true, message: '请输入应用公钥证书', trigger: 'blur' }
        // ]
      }
    };
  },
  computed: {
    currentChannelLabel: function currentChannelLabel() {
      var _this = this;
      var item = this.channelList.find(function (c) {
        return c.value === _this.activeChannel;
      });
      return item ? item.label : '';
    }
  },
  watch: {
    // tab 切换时重新查询下方列表
    tabChannel: function tabChannel() {
      this.page = 1;
      this.queryTransferAccountPage();
    }
  },
  created: function created() {
    this.queryTransferAccountPage();
    this.queryTransferChannelConfig();
    this.queryKapayerBaseConfig();
  },
  methods: {
    // 查询当前渠道配置（TRANSFER_CHANNEL）
    queryTransferChannelConfig: function () {
      var _queryTransferChannelConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res, channelCode;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _paymentSettings.queryTenantBizConfig)({
                configKey: 'TRANSFER_CHANNEL'
              });
            case 1:
              res = _context.v;
              if (res.code === 0 && res.data && res.data.config) {
                channelCode = res.data.config.channelCode;
                if (channelCode) {
                  this.activeChannel = channelCode;
                }
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function queryTransferChannelConfig() {
        return _queryTransferChannelConfig.apply(this, arguments);
      }
      return queryTransferChannelConfig;
    }(),
    // 查询快安支付基础配置（KAPAYER）
    queryKapayerBaseConfig: function () {
      var _queryKapayerBaseConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _paymentSettings.queryTenantBizConfig)({
                configKey: 'KAPAYER'
              });
            case 1:
              res = _context2.v;
              if (res.code === 0 && res.data && res.data.config) {
                this.kapayerBaseConfig = {
                  appKey: res.data.config.appId || '',
                  appSecret: res.data.config.appSecret || '',
                  jobId: res.data.config.jobId || ''
                };
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function queryKapayerBaseConfig() {
        return _queryKapayerBaseConfig.apply(this, arguments);
      }
      return queryKapayerBaseConfig;
    }(),
    // 顶部 tab 切换（不影响右侧"当前渠道"，只切换列表）
    onSwitchChannel: function onSwitchChannel(item) {
      this.tabChannel = item.value;
    },
    // 点击更换按钮，弹出更换渠道弹窗
    onChangeChannel: function onChangeChannel() {
      this.changeChannelValue = this.activeChannel;
      this.changeChannelDialogVisible = true;
    },
    // 弹窗内点击确认，弹出二次确认
    onChangeChannelConfirm: function onChangeChannelConfirm() {
      var _this2 = this;
      if (this.changeChannelValue === this.activeChannel) {
        this.$message.warning('所选渠道与当前渠道一致，无需切换');
        return;
      }
      this.$confirm('当前转账渠道即将切换，切换后平台全部打款将使用新渠道账号，该操作将影响资金流转，确定继续切换吗？', '温馨提示', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        _this2.doSaveChannel();
      }).catch(function () {});
    },
    // 调用保存租户业务配置接口，configKey=TRANSFER_CHANNEL
    doSaveChannel: function () {
      var _doSaveChannel = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return (0, _paymentSettings.saveTenantBizConfig)({
                configKey: 'TRANSFER_CHANNEL',
                config: {
                  channelCode: this.changeChannelValue
                }
              });
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.activeChannel = this.changeChannelValue;
                this.changeChannelDialogVisible = false;
                this.$message.success('渠道切换成功');
              } else {
                this.$message.error(res.msg || '渠道切换失败');
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function doSaveChannel() {
        return _doSaveChannel.apply(this, arguments);
      }
      return doSaveChannel;
    }(),
    // 弹窗关闭（重置选中）
    onChangeChannelClose: function onChangeChannelClose() {
      this.changeChannelDialogVisible = false;
      this.changeChannelValue = this.activeChannel;
    },
    onAddAccount: function onAddAccount() {
      if (this.tabChannel === 'kapayer') {
        // 快安支付添加账本
        this.kapayerAddDialogType = 'add';
        this.kapayerAddEditingId = null;
        this.kapayerAddForm = {
          bookName: '',
          accountBookId: ''
        };
        this.kapayerAddDialogVisible = true;
        return;
      }
      // 支付宝添加转账账号（原有逻辑保持不变）
      this.title = '添加转账账号';
      this.OperationType = 'add';
      this.dialogVisible = true;
    },
    onEditor: function onEditor(alipayAppId) {
      this.title = '编辑转账账号';
      this.OperationType = 'Editor';
      this.queryTransferAccountDetail(alipayAppId);
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.handleReset();
      this.dialogVisible = false;
      this.onInit();
    },
    onInit: function onInit() {
      this.ruFrom = {
        remark: '',
        alipayAppId: '',
        rootCertContent: '',
        publicKey: '',
        privateKey: '',
        alipayPublicCertContent: '',
        certContent: ''
      };
    },
    handleSizeChange: function handleSizeChange(val) {
      this.size = val;
      this.queryTransferAccountPage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.queryTransferAccountPage();
    },
    queryTransferAccountPage: function () {
      var _queryTransferAccountPage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _params, _res;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.loading = true;
              if (!(this.tabChannel === 'kapayer')) {
                _context4.n = 2;
                break;
              }
              // 快安支付记账本列表
              params = {
                page: this.page,
                size: this.size
              };
              _context4.n = 1;
              return (0, _paymentSettings.queryKapayerBookList)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.kapayerTableData = res.data.data;
                this.kapayerTotal = res.data.total;
              } else {
                this.$message.error(res.msg);
              }
              _context4.n = 4;
              break;
            case 2:
              // 支付宝转账账号列表
              _params = {
                page: this.page,
                size: this.size
              };
              _context4.n = 3;
              return (0, _paymentSettings.queryTransferAccountPage)(_params);
            case 3:
              _res = _context4.v;
              if (_res.code === 0) {
                this.alipayTableData = _res.data.data;
                this.alipayTotal = _res.data.total;
              } else {
                this.$message.error(_res.msg);
              }
            case 4:
              this.loading = false;
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function queryTransferAccountPage() {
        return _queryTransferAccountPage2.apply(this, arguments);
      }
      return queryTransferAccountPage;
    }(),
    // 快安支付-编辑（先查详情再打开弹窗回显）
    onEditorKapayer: function () {
      var _onEditorKapayer = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(row) {
        var res;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.loading = true;
              _context5.n = 1;
              return (0, _paymentSettings.queryKapayerBookDetail)({
                id: row.id
              });
            case 1:
              res = _context5.v;
              this.loading = false;
              if (res.code === 0 && res.data) {
                this.kapayerAddDialogType = 'edit';
                this.kapayerAddEditingId = res.data.id;
                this.kapayerAddForm = {
                  bookName: res.data.bookName || '',
                  accountBookId: res.data.accountBookId || ''
                };
                this.kapayerAddDialogVisible = true;
              } else {
                this.$message.error(res.msg || '查询详情失败');
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function onEditorKapayer(_x) {
        return _onEditorKapayer.apply(this, arguments);
      }
      return onEditorKapayer;
    }(),
    // 快安支付-删除
    onDelKapayer: function onDelKapayer(row) {
      var _this3 = this;
      this.$confirm('确定要删除该记账本吗？', '删除记账本', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var res;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return (0, _paymentSettings.deleteKapayerBook)({
                id: row.id
              });
            case 1:
              res = _context6.v;
              if (res.code === 0) {
                _this3.$message.success('删除成功');
                _this3.page = 1;
                _this3.queryTransferAccountPage();
              } else {
                _this3.$message.error(res.msg || '删除失败');
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))).catch(function () {});
    },
    // 快安支付-设为当前使用
    onSetDefaultKapayer: function onSetDefaultKapayer(row) {
      var _this4 = this;
      this.$confirm(
      // '设为使用后，当前使用的账本将被替换，确定继续？',
      '确认切换当前渠道下的默认转账账号?', '设为使用', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7() {
        var res;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return (0, _paymentSettings.saveKapayerBook)({
                operateType: 2,
                id: row.id
              });
            case 1:
              res = _context7.v;
              if (res.code === 0) {
                _this4.$message.success('操作成功');
                _this4.page = 1;
                _this4.queryTransferAccountPage();
              } else {
                _this4.$message.error(res.msg || '操作失败');
              }
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))).catch(function () {});
    },
    // 快安支付-余额同步
    onSyncBalance: function onSyncBalance(row) {
      var _this5 = this;
      this.$confirm('确定要同步该记账本的余额吗？', '余额同步', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee8() {
        var res;
        return (0, _regenerator2.default)().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return (0, _paymentSettings.syncKapayerBookBalance)({
                id: row.id
              });
            case 1:
              res = _context8.v;
              if (res.code === 0) {
                _this5.$message.success('余额同步成功');
                _this5.queryTransferAccountPage();
              } else {
                _this5.$message.error(res.msg || '余额同步失败');
              }
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))).catch(function () {});
    },
    // 快安支付-编辑基础配置（打开弹窗并回显）
    onEditKapayerBase: function onEditKapayerBase() {
      this.kapayerBaseEditForm = {
        appKey: this.kapayerBaseConfig.appKey || '',
        appSecret: this.kapayerBaseConfig.appSecret || '',
        jobId: this.kapayerBaseConfig.jobId || ''
      };
      this.kapayerBaseEditDialogVisible = true;
    },
    // 快安支付-基础配置 确认（表单校验 → 二次确认 → 调保存接口）
    onKapayerBaseEditConfirm: function onKapayerBaseEditConfirm() {
      var _this6 = this;
      this.$refs.kapayerBaseEditForm.validate(function (valid) {
        if (!valid) {
          _this6.$message.error('请填写所有必填项');
          return false;
        }
        _this6.$confirm('保存后，快安支付相关配置将立即生效，是否继续？', '编辑基础配置', {
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(function () {
          _this6.doSaveKapayerBase();
        }).catch(function () {});
      });
    },
    // 调用保存租户业务配置接口，configKey=KAPAYER
    doSaveKapayerBase: function () {
      var _doSaveKapayerBase = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee9() {
        var res;
        return (0, _regenerator2.default)().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return (0, _paymentSettings.saveTenantBizConfig)({
                configKey: 'KAPAYER',
                config: {
                  appId: this.kapayerBaseEditForm.appKey,
                  appSecret: this.kapayerBaseEditForm.appSecret,
                  jobId: this.kapayerBaseEditForm.jobId
                }
              });
            case 1:
              res = _context9.v;
              if (res.code === 0) {
                this.$message.success('保存成功');
                this.kapayerBaseEditDialogVisible = false;
                // 重新查询基础配置以更新头部展示
                this.queryKapayerBaseConfig();
              } else {
                this.$message.error(res.msg || '保存失败');
              }
            case 2:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function doSaveKapayerBase() {
        return _doSaveKapayerBase.apply(this, arguments);
      }
      return doSaveKapayerBase;
    }(),
    // 快安支付-基础配置 重置
    onKapayerBaseEditReset: function onKapayerBaseEditReset() {
      this.$refs.kapayerBaseEditForm.resetFields();
    },
    // 快安支付-基础配置 弹窗关闭
    onKapayerBaseEditClose: function onKapayerBaseEditClose() {
      var _this7 = this;
      this.kapayerBaseEditDialogVisible = false;
      this.kapayerBaseEditForm = {
        appKey: '',
        appSecret: '',
        jobId: ''
      };
      this.$nextTick(function () {
        if (_this7.$refs.kapayerBaseEditForm) {
          _this7.$refs.kapayerBaseEditForm.clearValidate();
        }
      });
    },
    // 快安支付-添加/编辑账本 确认（先表单校验 → 二次确认 → 调保存接口）
    onKapayerAddConfirm: function onKapayerAddConfirm() {
      var _this8 = this;
      this.$refs.kapayerAddForm.validate(function (valid) {
        if (!valid) {
          _this8.$message.error('请填写所有必填项');
          return false;
        }
        var isEdit = _this8.kapayerAddDialogType === 'edit';
        _this8.$confirm(isEdit ? '确定要保存对该账本的修改吗？' : '确定要添加该账本吗？该操作将影响资金账户配置，请谨慎操作。', isEdit ? '编辑账本' : '添加账本', {
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(function () {
          _this8.doSaveKapayerBook();
        }).catch(function () {});
      });
    },
    // 调用保存快安支付记账本接口，operateType=1 新增或修改、operateType=2 设为使用
    doSaveKapayerBook: function () {
      var _doSaveKapayerBook = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee0() {
        var isEdit, params, res;
        return (0, _regenerator2.default)().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              isEdit = this.kapayerAddDialogType === 'edit';
              params = {
                operateType: 1,
                bookName: this.kapayerAddForm.bookName,
                accountBookId: this.kapayerAddForm.accountBookId
              };
              if (isEdit) {
                params.id = this.kapayerAddEditingId;
              }
              _context0.n = 1;
              return (0, _paymentSettings.saveKapayerBook)(params);
            case 1:
              res = _context0.v;
              if (res.code === 0) {
                this.$message.success(isEdit ? '编辑成功' : '添加成功');
                this.kapayerAddDialogVisible = false;
                this.page = 1;
                this.queryTransferAccountPage();
              } else {
                this.$message.error(res.msg || (isEdit ? '编辑失败' : '添加失败'));
              }
            case 2:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function doSaveKapayerBook() {
        return _doSaveKapayerBook.apply(this, arguments);
      }
      return doSaveKapayerBook;
    }(),
    // 快安支付-添加/编辑账本 重置
    onKapayerAddReset: function onKapayerAddReset() {
      this.onKapayerAddClose();
    },
    // 快安支付-添加/编辑账本 弹窗关闭
    onKapayerAddClose: function onKapayerAddClose() {
      var _this9 = this;
      this.kapayerAddDialogVisible = false;
      this.kapayerAddDialogType = 'add';
      this.kapayerAddEditingId = null;
      this.kapayerAddForm = {
        bookName: '',
        accountBookId: ''
      };
      this.$nextTick(function () {
        if (_this9.$refs.kapayerAddForm) {
          _this9.$refs.kapayerAddForm.clearValidate();
        }
      });
    },
    submitForm: function submitForm() {
      var _this0 = this;
      this.$refs.ruFrom.validate(function (valid) {
        if (valid) {
          _this0.$confirm('是否保存此设置？', '提示', {
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(function () {
            _this0.editTransferAccount();
          });
        } else {
          _this0.$message.error('请填写所有必填项');
          return false;
        }
      });
    },
    handleReset: function handleReset() {
      this.$refs.ruFrom.resetFields();
    },
    editTransferAccount: function () {
      var _editTransferAccount2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee1() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              this.loading = true;
              params = (0, _objectSpread2.default)({}, this.ruFrom);
              _context1.n = 1;
              return (0, _paymentSettings.editTransferAccount)(params);
            case 1:
              res = _context1.v;
              if (res.code === 0) {
                this.$message.success('操作成功');
                this.queryTransferAccountPage();
                this.onClose();
              } else {
                this.$message.error(res.msg);
              }
              this.loading = false;
            case 2:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function editTransferAccount() {
        return _editTransferAccount2.apply(this, arguments);
      }
      return editTransferAccount;
    }(),
    onSetDefault: function onSetDefault(alipayAppId) {
      var _this1 = this;
      this.$confirm('<div style="display:flex;justify-content:center;font-weight:bold">确认设置为默认转账账号?</div><div style="display:flex;justify-content:center;color:red;font-weight:bold">注:确认后，原先默认账号将被替换，谨慎操作</div>', '提示', {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        _this1.setDefaultTransferAccount(alipayAppId);
      });
    },
    setDefaultTransferAccount: function () {
      var _setDefaultTransferAccount2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee10(alipayAppId) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              this.loading = true;
              params = {
                alipayAppId: alipayAppId
              };
              _context10.n = 1;
              return (0, _paymentSettings.setDefaultTransferAccount)(params);
            case 1:
              res = _context10.v;
              if (res.code === 0) {
                this.$message.success('操作成功');
                this.queryTransferAccountPage();
                this.onClose();
              } else {
                this.$message.error(res.msg);
              }
              this.loading = false;
            case 2:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function setDefaultTransferAccount(_x2) {
        return _setDefaultTransferAccount2.apply(this, arguments);
      }
      return setDefaultTransferAccount;
    }(),
    onDel: function onDel(alipayAppId) {
      var _this10 = this;
      this.$confirm('确认删除此转账账号？', '提示', {
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        _this10.deleteTransferAccount(alipayAppId);
      });
    },
    deleteTransferAccount: function () {
      var _deleteTransferAccount2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee11(alipayAppId) {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              this.loading = true;
              _context11.p = 1;
              params = {
                alipayAppId: alipayAppId
              };
              _context11.n = 2;
              return (0, _paymentSettings.deleteTransferAccount)(params);
            case 2:
              res = _context11.v;
              if (res.code === 0) {
                this.$message.success('操作成功');
                this.queryTransferAccountPage();
                this.onClose();
              } else {
                this.$message.error(res.msg || '操作失败');
              }
              _context11.n = 4;
              break;
            case 3:
              _context11.p = 3;
              _t = _context11.v;
            case 4:
              _context11.p = 4;
              this.loading = false;
              return _context11.f(4);
            case 5:
              return _context11.a(2);
          }
        }, _callee11, this, [[1, 3, 4, 5]]);
      }));
      function deleteTransferAccount(_x3) {
        return _deleteTransferAccount2.apply(this, arguments);
      }
      return deleteTransferAccount;
    }(),
    queryTransferAccountDetail: function () {
      var _queryTransferAccountDetail2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee12(alipayAppId) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              this.loading = true;
              params = {
                alipayAppId: alipayAppId
              };
              _context12.n = 1;
              return (0, _paymentSettings.queryTransferAccountDetail)(params);
            case 1:
              res = _context12.v;
              if (res.code === 0) {
                this.ruFrom.remark = res.data.remark;
                this.ruFrom.alipayAppId = res.data.alipayAppId;
                this.ruFrom.rootCertContent = res.data.rootCertContent;
                this.ruFrom.publicKey = res.data.publicKey;
                this.ruFrom.privateKey = res.data.privateKey;
                this.ruFrom.alipayPublicCertContent = res.data.publicCertContent;
                this.ruFrom.certContent = res.data.certContent;
              } else {
                this.$message.error(res.msg);
              }
              this.loading = false;
            case 2:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function queryTransferAccountDetail(_x4) {
        return _queryTransferAccountDetail2.apply(this, arguments);
      }
      return queryTransferAccountDetail;
    }()
  }
};